/* Progressive enhancement: content is visible when JavaScript or motion is unavailable. */
(() => {
  if (window.ArnavReveal) return;
  const bound = new WeakSet();
  function init(root = document) {
    root.querySelectorAll('[data-arnav-reveal]').forEach(element => {
      if (bound.has(element)) return;
      bound.add(element);
      if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) {
        element.classList.add('is-visible', 'is-animated');
        return;
      }
      element.classList.add('arnav-reveal-pending');
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          element.classList.remove('arnav-reveal-pending');
          element.classList.add('is-visible', 'is-animated');
          observer.disconnect();
        }
      }, { threshold: .05 });
      observer.observe(element);
    });
  }
  window.ArnavReveal = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
